module.exports = __webpack_public_path__ + "img/expeditionary-hotspot-5.3f0f2dfd.png";